export class BatchPredictionMonitorDataName {
  /**
   * Create a Batch Prediction Monitor Data Name
   * @param {string} plateId - monitor output plateId
   * @param {string} date - monitor output date
   * @param {string} timestamp - monitor output timestamp
   * @param {string} batchExecutionId - monitor output batchExecutionId
   * @param {object} sides - monitor output sides
   */
  constructor(plateId, date, timestamp, batchExecutionId, sides) {
    /** @type {string} */
    this.plateId = plateId;

    /** @type {string} */
    this.date = date;

    /** @type {string} */
    this.timestamp = timestamp;

    /** @type {string} */
    this.batchExecutionId = batchExecutionId;

    /** @type {object} */
    this.sides = sides;
  }

  /**
   * Map data from api to instance of BatchPredictionMonitorDataName
   * @returns {BatchPredictionMonitorDataName} new instance with the mapped data
   */
  static fromApi({ plate_id, date, timestamp, batch_execution_id, sides }) {
    return new BatchPredictionMonitorDataName(plate_id, date, timestamp, batch_execution_id, sides);
  }
}
